export default __webpack_public_path__ + "static/media/1N.8e41aaf7.png";